const Header = ({ logoComunidad }) => {
  return (
    <div className="flex flex-col items-center text-center text-white">
      <div className="mb-2 flex items-center gap-1.5 lg:mb-1 lg:gap-1.5">
        <img src={logoComunidad} alt="" className="h-6 w-6 object-contain lg:h-6 lg:w-6" />
        <span className="text-xs font-semibold lg:text-xs">Comunidad</span>
      </div>
      <h1 className="text-xl font-bold leading-tight mb-2 sm:text-2xl lg:mb-1 lg:text-2xl xl:text-2xl">
        Geopuntos Esri
      </h1>
      <h2 className="text-xs font-semibold mb-0.5 sm:text-sm lg:mb-0.5 lg:text-xs">
        Bienvenido
      </h2>
      <h3 className="mb-2 whitespace-nowrap text-[9px] text-white/85 sm:text-[10px] md:text-xs lg:mb-1.5 lg:text-xs">
        Ser parte de la Comunidad Esri tiene beneficios
      </h3>
    </div>
  );
};

export default Header;
